module.exports = __webpack_public_path__ + "images/postnl_small0265a443edfd8f52f362dd43727bc2e2.png";